import { makePieActionObjs } from 'shared/imports/pieActionGenerators'
import { prependAppName } from 'shared/imports/sharedHelperFunctions'

const appName = '@@issueManagement/'

const getIssueManagementListsObj = makePieActionObjs('get', 'issue_management_lists')
const getIssueManagementListItemsObj = makePieActionObjs('get', 'issue_management_list_items')
const submitIssueManagementProjectObj = makePieActionObjs('post', 'issue_management')
const addIssueManagementListItemObj = makePieActionObjs('post', 'issue_management_list_item')
const getIssueManagementFormObj = makePieActionObjs('get', 'issue_management_form')
const removeIssueManagementListItemObj = makePieActionObjs('delete', 'issue_management_list_item')
const editIssueManagementObj = makePieActionObjs('patch', 'issue_management')
const editDataDescriptionForIssueManagementObj = makePieActionObjs('patch', 'data_description')

const submitNewListObj = makePieActionObjs('post', 'new_list')
const editNewListObj = makePieActionObjs("patch", "new_list")
const deleteListObj = makePieActionObjs('delete', 'new_list')


export const getIssueManagementLists = prependAppName(appName, getIssueManagementListsObj.pieDict)
export const getIssueManagementListItems = prependAppName(appName, getIssueManagementListItemsObj.pieDict)
export const submitIssueManagementProject = prependAppName(appName, submitIssueManagementProjectObj.pieDict)
export const addIssueManagementListItem = prependAppName(appName, addIssueManagementListItemObj.pieDict)
export const getIssueManagementForm = prependAppName(appName, getIssueManagementFormObj.pieDict)
export const removeIssueManagementListItem = prependAppName(appName, getIssueManagementFormObj.pieDict)
export const editIssueManagement = prependAppName(appName, editIssueManagementObj.pieDict)
export const editDataDescriptionForIssueManagement = prependAppName(appName, editDataDescriptionForIssueManagementObj.pieDict)

export const submitNewList = prependAppName(appName, submitNewListObj.pieDict)
export const editNewList = prependAppName(appName,editNewListObj.pieDict)
export const deleteList = prependAppName(appName, deleteListObj.pieDict)


const actionTypes = prependAppName(
    appName,
    {
        updateSort: 'UPDATE_SORT',
        updateFilter: 'UPDATE_FILTER',
        editNewListForm: 'EDIT_NEW_LIST_FORM',
        openCloseNewListForm: 'OPEN_CLOSE_NEW_LIST_FORM',
        ...getIssueManagementListsObj.actionTypes,
        ...getIssueManagementListItemsObj.actionTypes,
        ...submitIssueManagementProjectObj.actionTypes,
        ...addIssueManagementListItemObj.actionTypes,
        ...getIssueManagementFormObj.actionTypes,
        ...removeIssueManagementListItemObj.actionTypes,
        ...editIssueManagementObj.actionTypes,
        ...editDataDescriptionForIssueManagementObj.actionTypes,
        ...submitNewListObj.actionTypes,
        ...editNewList.actionTypes,
        ...deleteListObj.actionTypes,
    }
)

export default actionTypes
